import React from "react";
import styles from "./ElectronicPaymentReceipt.module.css";
import "../../../App.css";
import Tafgeet from "tafgeetjs";
function ElectronicPaymentReceipt(props) {
  return (
    <>
      <div className={`${styles["box-header"]}`}>
        <h3
          className={`${styles["box-title"]} mb-0 mx-5`}
          Style="color:#005da8"
        >
          إيصال السداد الإلكتروني
        </h3>
      </div>
      <ul
        className={`${styles["custom-list"]} list-group list-group-flush m-lg-5`}
      >
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>مسلسل:</span>
          <span className={styles["text-value"]}></span>
        </li>
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>مكتب التحصيل الفرعي:</span>
          <span></span>
        </li>
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>كود حساب الوحدة:</span>
          <span className={styles["text-value"]}>
            {props.data.payment ? props.data.payment.acc_key : ""}
          </span>
        </li>
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>الكود المؤسسي:</span>
          <span className={styles["text-value"]}>
            {props.data.payment ? props.data.payment.serial : ""}
          </span>
        </li>
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>الوصف:</span>
          <span className={styles["text-value"]}>
            {props.data.payment && props.data.payment.gov ? `محافظة ` : ""}
            {props.data.payment && props.data.payment.gov
              ? `${props.data.payment.gov} - `
              : ""}
            {props.data.payment && props.data.payment.district
              ? `${props.data.payment.district} - `
              : ""}
            {props.data.payment && props.data.payment.village
              ? `${props.data.payment.village}  ${
                  props.data.payment.place ? "- " : "- شارع "
                }`
              : ""}
            {props.data.payment && props.data.payment.place
              ? `${props.data.payment.place} - شارع `
              : ""}
            {props.data.payment && props.data.payment.street
              ? `${props.data.payment.street} - رقم العقار `
              : ""}
            {props.data.payment && props.data.payment.build
              ? `${props.data.payment.build} - الدور `
              : ""}
            {props.data.payment && props.data.payment.part
              ? `${props.data.payment.part} - رقم الوحدة `
              : ""}
            {props.data.payment && props.data.payment.unit
              ? props.data.payment.unit
              : ""}
          </span>
        </li>
        <li className="list-group-item  d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>
            اسم متلقى الخدمة (الشاغل):
          </span>
          <span className={styles["text-value"]}>
            {props.data.payment ? props.data.payment.occupant_name : ""}
          </span>
        </li>
        <li className="list-group-item  d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>المبلغ بالأرقام:</span>
          <span className={styles["text-value"]}>
            {props.data.payment ? props.data.settlementAccountAmount : ""}
          </span>
        </li>
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <span className={styles["text-title"]}>المبلغ بالحروف:</span>
          <span className={styles["text-value"]}>
            {props.data.payment
              ? new Tafgeet(props.data.settlementAccountAmount, "EGP").parse()
              : ""}
          </span>
        </li>
        <li className="list-group-item">
          <span className={styles["text-title"]}>التلحيق بالإيصالات:</span>
          <span className={styles["text-value"]}></span>
        </li>
      </ul>
    </>
  );
}
export default ElectronicPaymentReceipt;
